/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * Zäkra API 1.0
 * REST API for Zäkra
 * OpenAPI spec version: v1
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';
import { useCallback } from 'react';
import type {
  AssignmentDTO,
  AssignmentRequestModel,
  CaseEventDTOWithUserDetails,
  FieldTesterIncompleteDayPlanDTO,
  GoSupportRequestFilters,
  StandbyFTDTO,
  TransportLogisticsGetAssignmentBookedToEditedByFieldtesterParams,
  TransportLogisticsGetAssignmentsBookedToTimePassedParams,
  TransportLogisticsGetAssignmentsEstimatedEndTimePassedParams,
  TransportLogisticsGetAssignmentsEstimatedStartTimePassedParams,
  TransportLogisticsGetAssignmentsNotYetAcceptedByFTForTomorrowParams,
  TransportLogisticsGetAssignmentsWithHotelBookedYesterdayParams,
  TransportLogisticsGetAssignmentsWithMissingExpectedExpensesParams,
  TransportLogisticsGetFieldtestersWithOutsideHomeCountyParams,
  TransportLogisticsGetPlaceholderCaseAssignmentsParams,
  TransportLogisticsGetStandbyFTDTOsParams,
  TransportLogisticsGetStandbyTimeAssignmentsParams,
  TransportLogisticsGetUnhandledAssignmentRescheduledToAfterMidnightParams,
  TransportLogisticsGetUnhandledDeviationReportsParams,
  TransportLogisticsGetUnhandledFaultyCarsParams,
  TransportLogisticsGetUnhandledFlaggedForSpeedingParams,
  TransportLogisticsGetUnhandledNoTyresLoadedEventsParams,
  TransportLogisticsGetUnhandledWorkGearReportsParams,
  TransportLogisticsGetUnreadCommentsParams,
} from '.././model';
import { useCustomInstance } from '.././mutator/custom-instance';

export const useTransportLogisticsGetStandbyFTDTOsHook = () => {
  const transportLogisticsGetStandbyFTDTOs =
    useCustomInstance<StandbyFTDTO[]>();

  return useCallback(
    (
      params?: TransportLogisticsGetStandbyFTDTOsParams,
      signal?: AbortSignal
    ) => {
      return transportLogisticsGetStandbyFTDTOs({
        url: `/api/TransportLogistics/GetStandbyFTDTOs`,
        method: 'GET',
        params,
        signal,
      });
    },
    [transportLogisticsGetStandbyFTDTOs]
  );
};

export const getTransportLogisticsGetStandbyFTDTOsQueryKey = (
  params?: TransportLogisticsGetStandbyFTDTOsParams
) => {
  return [
    `/api/TransportLogistics/GetStandbyFTDTOs`,
    ...(params ? [params] : []),
  ] as const;
};

export const useTransportLogisticsGetStandbyFTDTOsQueryOptions = <
  TData = Awaited<
    ReturnType<ReturnType<typeof useTransportLogisticsGetStandbyFTDTOsHook>>
  >,
  TError = unknown,
>(
  params?: TransportLogisticsGetStandbyFTDTOsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<
        ReturnType<ReturnType<typeof useTransportLogisticsGetStandbyFTDTOsHook>>
      >,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getTransportLogisticsGetStandbyFTDTOsQueryKey(params);

  const transportLogisticsGetStandbyFTDTOs =
    useTransportLogisticsGetStandbyFTDTOsHook();

  const queryFn: QueryFunction<
    Awaited<
      ReturnType<ReturnType<typeof useTransportLogisticsGetStandbyFTDTOsHook>>
    >
  > = ({ signal }) => transportLogisticsGetStandbyFTDTOs(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<
      ReturnType<ReturnType<typeof useTransportLogisticsGetStandbyFTDTOsHook>>
    >,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type TransportLogisticsGetStandbyFTDTOsQueryResult = NonNullable<
  Awaited<
    ReturnType<ReturnType<typeof useTransportLogisticsGetStandbyFTDTOsHook>>
  >
>;
export type TransportLogisticsGetStandbyFTDTOsQueryError = unknown;

export const useTransportLogisticsGetStandbyFTDTOs = <
  TData = Awaited<
    ReturnType<ReturnType<typeof useTransportLogisticsGetStandbyFTDTOsHook>>
  >,
  TError = unknown,
>(
  params?: TransportLogisticsGetStandbyFTDTOsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<
        ReturnType<ReturnType<typeof useTransportLogisticsGetStandbyFTDTOsHook>>
      >,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = useTransportLogisticsGetStandbyFTDTOsQueryOptions(
    params,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const useTransportLogisticsGetPlaceholderCaseAssignmentsHook = () => {
  const transportLogisticsGetPlaceholderCaseAssignments =
    useCustomInstance<AssignmentDTO[]>();

  return useCallback(
    (
      params?: TransportLogisticsGetPlaceholderCaseAssignmentsParams,
      signal?: AbortSignal
    ) => {
      return transportLogisticsGetPlaceholderCaseAssignments({
        url: `/api/TransportLogistics/GetPlaceholderCaseAssignments`,
        method: 'GET',
        params,
        signal,
      });
    },
    [transportLogisticsGetPlaceholderCaseAssignments]
  );
};

export const getTransportLogisticsGetPlaceholderCaseAssignmentsQueryKey = (
  params?: TransportLogisticsGetPlaceholderCaseAssignmentsParams
) => {
  return [
    `/api/TransportLogistics/GetPlaceholderCaseAssignments`,
    ...(params ? [params] : []),
  ] as const;
};

export const useTransportLogisticsGetPlaceholderCaseAssignmentsQueryOptions = <
  TData = Awaited<
    ReturnType<
      ReturnType<typeof useTransportLogisticsGetPlaceholderCaseAssignmentsHook>
    >
  >,
  TError = unknown,
>(
  params?: TransportLogisticsGetPlaceholderCaseAssignmentsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<
        ReturnType<
          ReturnType<
            typeof useTransportLogisticsGetPlaceholderCaseAssignmentsHook
          >
        >
      >,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getTransportLogisticsGetPlaceholderCaseAssignmentsQueryKey(params);

  const transportLogisticsGetPlaceholderCaseAssignments =
    useTransportLogisticsGetPlaceholderCaseAssignmentsHook();

  const queryFn: QueryFunction<
    Awaited<
      ReturnType<
        ReturnType<
          typeof useTransportLogisticsGetPlaceholderCaseAssignmentsHook
        >
      >
    >
  > = ({ signal }) =>
    transportLogisticsGetPlaceholderCaseAssignments(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<
      ReturnType<
        ReturnType<
          typeof useTransportLogisticsGetPlaceholderCaseAssignmentsHook
        >
      >
    >,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type TransportLogisticsGetPlaceholderCaseAssignmentsQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        ReturnType<
          typeof useTransportLogisticsGetPlaceholderCaseAssignmentsHook
        >
      >
    >
  >;
export type TransportLogisticsGetPlaceholderCaseAssignmentsQueryError = unknown;

export const useTransportLogisticsGetPlaceholderCaseAssignments = <
  TData = Awaited<
    ReturnType<
      ReturnType<typeof useTransportLogisticsGetPlaceholderCaseAssignmentsHook>
    >
  >,
  TError = unknown,
>(
  params?: TransportLogisticsGetPlaceholderCaseAssignmentsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<
        ReturnType<
          ReturnType<
            typeof useTransportLogisticsGetPlaceholderCaseAssignmentsHook
          >
        >
      >,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions =
    useTransportLogisticsGetPlaceholderCaseAssignmentsQueryOptions(
      params,
      options
    );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const useTransportLogisticsGetAssignmentsWithMissingExpectedExpensesHook =
  () => {
    const transportLogisticsGetAssignmentsWithMissingExpectedExpenses =
      useCustomInstance<AssignmentDTO[]>();

    return useCallback(
      (
        params?: TransportLogisticsGetAssignmentsWithMissingExpectedExpensesParams,
        signal?: AbortSignal
      ) => {
        return transportLogisticsGetAssignmentsWithMissingExpectedExpenses({
          url: `/api/TransportLogistics/GetAssignmentsWithMissingExpectedExpenses`,
          method: 'GET',
          params,
          signal,
        });
      },
      [transportLogisticsGetAssignmentsWithMissingExpectedExpenses]
    );
  };

export const getTransportLogisticsGetAssignmentsWithMissingExpectedExpensesQueryKey =
  (
    params?: TransportLogisticsGetAssignmentsWithMissingExpectedExpensesParams
  ) => {
    return [
      `/api/TransportLogistics/GetAssignmentsWithMissingExpectedExpenses`,
      ...(params ? [params] : []),
    ] as const;
  };

export const useTransportLogisticsGetAssignmentsWithMissingExpectedExpensesQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        ReturnType<
          typeof useTransportLogisticsGetAssignmentsWithMissingExpectedExpensesHook
        >
      >
    >,
    TError = unknown,
  >(
    params?: TransportLogisticsGetAssignmentsWithMissingExpectedExpensesParams,
    options?: {
      query?: UseQueryOptions<
        Awaited<
          ReturnType<
            ReturnType<
              typeof useTransportLogisticsGetAssignmentsWithMissingExpectedExpensesHook
            >
          >
        >,
        TError,
        TData
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getTransportLogisticsGetAssignmentsWithMissingExpectedExpensesQueryKey(
        params
      );

    const transportLogisticsGetAssignmentsWithMissingExpectedExpenses =
      useTransportLogisticsGetAssignmentsWithMissingExpectedExpensesHook();

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          ReturnType<
            typeof useTransportLogisticsGetAssignmentsWithMissingExpectedExpensesHook
          >
        >
      >
    > = ({ signal }) =>
      transportLogisticsGetAssignmentsWithMissingExpectedExpenses(
        params,
        signal
      );

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<
          ReturnType<
            typeof useTransportLogisticsGetAssignmentsWithMissingExpectedExpensesHook
          >
        >
      >,
      TError,
      TData
    > & { queryKey: QueryKey };
  };

export type TransportLogisticsGetAssignmentsWithMissingExpectedExpensesQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        ReturnType<
          typeof useTransportLogisticsGetAssignmentsWithMissingExpectedExpensesHook
        >
      >
    >
  >;
export type TransportLogisticsGetAssignmentsWithMissingExpectedExpensesQueryError =
  unknown;

export const useTransportLogisticsGetAssignmentsWithMissingExpectedExpenses = <
  TData = Awaited<
    ReturnType<
      ReturnType<
        typeof useTransportLogisticsGetAssignmentsWithMissingExpectedExpensesHook
      >
    >
  >,
  TError = unknown,
>(
  params?: TransportLogisticsGetAssignmentsWithMissingExpectedExpensesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<
        ReturnType<
          ReturnType<
            typeof useTransportLogisticsGetAssignmentsWithMissingExpectedExpensesHook
          >
        >
      >,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions =
    useTransportLogisticsGetAssignmentsWithMissingExpectedExpensesQueryOptions(
      params,
      options
    );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const useTransportLogisticsGetAssignmentsWithHotelBookedYesterdayHook =
  () => {
    const transportLogisticsGetAssignmentsWithHotelBookedYesterday =
      useCustomInstance<AssignmentDTO[]>();

    return useCallback(
      (
        params?: TransportLogisticsGetAssignmentsWithHotelBookedYesterdayParams,
        signal?: AbortSignal
      ) => {
        return transportLogisticsGetAssignmentsWithHotelBookedYesterday({
          url: `/api/TransportLogistics/GetAssignmentsWithHotelBookedYesterday`,
          method: 'GET',
          params,
          signal,
        });
      },
      [transportLogisticsGetAssignmentsWithHotelBookedYesterday]
    );
  };

export const getTransportLogisticsGetAssignmentsWithHotelBookedYesterdayQueryKey =
  (params?: TransportLogisticsGetAssignmentsWithHotelBookedYesterdayParams) => {
    return [
      `/api/TransportLogistics/GetAssignmentsWithHotelBookedYesterday`,
      ...(params ? [params] : []),
    ] as const;
  };

export const useTransportLogisticsGetAssignmentsWithHotelBookedYesterdayQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        ReturnType<
          typeof useTransportLogisticsGetAssignmentsWithHotelBookedYesterdayHook
        >
      >
    >,
    TError = unknown,
  >(
    params?: TransportLogisticsGetAssignmentsWithHotelBookedYesterdayParams,
    options?: {
      query?: UseQueryOptions<
        Awaited<
          ReturnType<
            ReturnType<
              typeof useTransportLogisticsGetAssignmentsWithHotelBookedYesterdayHook
            >
          >
        >,
        TError,
        TData
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getTransportLogisticsGetAssignmentsWithHotelBookedYesterdayQueryKey(
        params
      );

    const transportLogisticsGetAssignmentsWithHotelBookedYesterday =
      useTransportLogisticsGetAssignmentsWithHotelBookedYesterdayHook();

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          ReturnType<
            typeof useTransportLogisticsGetAssignmentsWithHotelBookedYesterdayHook
          >
        >
      >
    > = ({ signal }) =>
      transportLogisticsGetAssignmentsWithHotelBookedYesterday(params, signal);

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<
          ReturnType<
            typeof useTransportLogisticsGetAssignmentsWithHotelBookedYesterdayHook
          >
        >
      >,
      TError,
      TData
    > & { queryKey: QueryKey };
  };

export type TransportLogisticsGetAssignmentsWithHotelBookedYesterdayQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        ReturnType<
          typeof useTransportLogisticsGetAssignmentsWithHotelBookedYesterdayHook
        >
      >
    >
  >;
export type TransportLogisticsGetAssignmentsWithHotelBookedYesterdayQueryError =
  unknown;

export const useTransportLogisticsGetAssignmentsWithHotelBookedYesterday = <
  TData = Awaited<
    ReturnType<
      ReturnType<
        typeof useTransportLogisticsGetAssignmentsWithHotelBookedYesterdayHook
      >
    >
  >,
  TError = unknown,
>(
  params?: TransportLogisticsGetAssignmentsWithHotelBookedYesterdayParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<
        ReturnType<
          ReturnType<
            typeof useTransportLogisticsGetAssignmentsWithHotelBookedYesterdayHook
          >
        >
      >,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions =
    useTransportLogisticsGetAssignmentsWithHotelBookedYesterdayQueryOptions(
      params,
      options
    );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const useTransportLogisticsGetFieldtestersWithOutsideHomeCountyHook =
  () => {
    const transportLogisticsGetFieldtestersWithOutsideHomeCounty =
      useCustomInstance<FieldTesterIncompleteDayPlanDTO[]>();

    return useCallback(
      (
        params?: TransportLogisticsGetFieldtestersWithOutsideHomeCountyParams,
        signal?: AbortSignal
      ) => {
        return transportLogisticsGetFieldtestersWithOutsideHomeCounty({
          url: `/api/TransportLogistics/GetFieldtestersWithOutsideHomeCounty`,
          method: 'GET',
          params,
          signal,
        });
      },
      [transportLogisticsGetFieldtestersWithOutsideHomeCounty]
    );
  };

export const getTransportLogisticsGetFieldtestersWithOutsideHomeCountyQueryKey =
  (params?: TransportLogisticsGetFieldtestersWithOutsideHomeCountyParams) => {
    return [
      `/api/TransportLogistics/GetFieldtestersWithOutsideHomeCounty`,
      ...(params ? [params] : []),
    ] as const;
  };

export const useTransportLogisticsGetFieldtestersWithOutsideHomeCountyQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        ReturnType<
          typeof useTransportLogisticsGetFieldtestersWithOutsideHomeCountyHook
        >
      >
    >,
    TError = unknown,
  >(
    params?: TransportLogisticsGetFieldtestersWithOutsideHomeCountyParams,
    options?: {
      query?: UseQueryOptions<
        Awaited<
          ReturnType<
            ReturnType<
              typeof useTransportLogisticsGetFieldtestersWithOutsideHomeCountyHook
            >
          >
        >,
        TError,
        TData
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getTransportLogisticsGetFieldtestersWithOutsideHomeCountyQueryKey(params);

    const transportLogisticsGetFieldtestersWithOutsideHomeCounty =
      useTransportLogisticsGetFieldtestersWithOutsideHomeCountyHook();

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          ReturnType<
            typeof useTransportLogisticsGetFieldtestersWithOutsideHomeCountyHook
          >
        >
      >
    > = ({ signal }) =>
      transportLogisticsGetFieldtestersWithOutsideHomeCounty(params, signal);

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<
          ReturnType<
            typeof useTransportLogisticsGetFieldtestersWithOutsideHomeCountyHook
          >
        >
      >,
      TError,
      TData
    > & { queryKey: QueryKey };
  };

export type TransportLogisticsGetFieldtestersWithOutsideHomeCountyQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        ReturnType<
          typeof useTransportLogisticsGetFieldtestersWithOutsideHomeCountyHook
        >
      >
    >
  >;
export type TransportLogisticsGetFieldtestersWithOutsideHomeCountyQueryError =
  unknown;

export const useTransportLogisticsGetFieldtestersWithOutsideHomeCounty = <
  TData = Awaited<
    ReturnType<
      ReturnType<
        typeof useTransportLogisticsGetFieldtestersWithOutsideHomeCountyHook
      >
    >
  >,
  TError = unknown,
>(
  params?: TransportLogisticsGetFieldtestersWithOutsideHomeCountyParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<
        ReturnType<
          ReturnType<
            typeof useTransportLogisticsGetFieldtestersWithOutsideHomeCountyHook
          >
        >
      >,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions =
    useTransportLogisticsGetFieldtestersWithOutsideHomeCountyQueryOptions(
      params,
      options
    );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const useTransportLogisticsGetRejectedAndNotHandledAssignmentRequestsHook =
  () => {
    const transportLogisticsGetRejectedAndNotHandledAssignmentRequests =
      useCustomInstance<AssignmentRequestModel[]>();

    return useCallback(
      (goSupportRequestFilters: GoSupportRequestFilters) => {
        return transportLogisticsGetRejectedAndNotHandledAssignmentRequests({
          url: `/api/TransportLogistics/GetRejectedAndNotHandledAssignmentRequests`,
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          data: goSupportRequestFilters,
        });
      },
      [transportLogisticsGetRejectedAndNotHandledAssignmentRequests]
    );
  };

export const useTransportLogisticsGetRejectedAndNotHandledAssignmentRequestsMutationOptions =
  <TError = unknown, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          ReturnType<
            typeof useTransportLogisticsGetRejectedAndNotHandledAssignmentRequestsHook
          >
        >
      >,
      TError,
      { data: GoSupportRequestFilters },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        ReturnType<
          typeof useTransportLogisticsGetRejectedAndNotHandledAssignmentRequestsHook
        >
      >
    >,
    TError,
    { data: GoSupportRequestFilters },
    TContext
  > => {
    const { mutation: mutationOptions } = options ?? {};

    const transportLogisticsGetRejectedAndNotHandledAssignmentRequests =
      useTransportLogisticsGetRejectedAndNotHandledAssignmentRequestsHook();

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          ReturnType<
            typeof useTransportLogisticsGetRejectedAndNotHandledAssignmentRequestsHook
          >
        >
      >,
      { data: GoSupportRequestFilters }
    > = (props) => {
      const { data } = props ?? {};

      return transportLogisticsGetRejectedAndNotHandledAssignmentRequests(data);
    };

    return { mutationFn, ...mutationOptions };
  };

export type TransportLogisticsGetRejectedAndNotHandledAssignmentRequestsMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        ReturnType<
          typeof useTransportLogisticsGetRejectedAndNotHandledAssignmentRequestsHook
        >
      >
    >
  >;
export type TransportLogisticsGetRejectedAndNotHandledAssignmentRequestsMutationBody =
  GoSupportRequestFilters;
export type TransportLogisticsGetRejectedAndNotHandledAssignmentRequestsMutationError =
  unknown;

export const useTransportLogisticsGetRejectedAndNotHandledAssignmentRequests = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<
      ReturnType<
        ReturnType<
          typeof useTransportLogisticsGetRejectedAndNotHandledAssignmentRequestsHook
        >
      >
    >,
    TError,
    { data: GoSupportRequestFilters },
    TContext
  >;
}): UseMutationResult<
  Awaited<
    ReturnType<
      ReturnType<
        typeof useTransportLogisticsGetRejectedAndNotHandledAssignmentRequestsHook
      >
    >
  >,
  TError,
  { data: GoSupportRequestFilters },
  TContext
> => {
  const mutationOptions =
    useTransportLogisticsGetRejectedAndNotHandledAssignmentRequestsMutationOptions(
      options
    );

  return useMutation(mutationOptions);
};
export const useTransportLogisticsGetUnreadCommentsHook = () => {
  const transportLogisticsGetUnreadComments =
    useCustomInstance<CaseEventDTOWithUserDetails[]>();

  return useCallback(
    (
      params?: TransportLogisticsGetUnreadCommentsParams,
      signal?: AbortSignal
    ) => {
      return transportLogisticsGetUnreadComments({
        url: `/api/TransportLogistics/GetUnreadComments`,
        method: 'GET',
        params,
        signal,
      });
    },
    [transportLogisticsGetUnreadComments]
  );
};

export const getTransportLogisticsGetUnreadCommentsQueryKey = (
  params?: TransportLogisticsGetUnreadCommentsParams
) => {
  return [
    `/api/TransportLogistics/GetUnreadComments`,
    ...(params ? [params] : []),
  ] as const;
};

export const useTransportLogisticsGetUnreadCommentsQueryOptions = <
  TData = Awaited<
    ReturnType<ReturnType<typeof useTransportLogisticsGetUnreadCommentsHook>>
  >,
  TError = unknown,
>(
  params?: TransportLogisticsGetUnreadCommentsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<
        ReturnType<
          ReturnType<typeof useTransportLogisticsGetUnreadCommentsHook>
        >
      >,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getTransportLogisticsGetUnreadCommentsQueryKey(params);

  const transportLogisticsGetUnreadComments =
    useTransportLogisticsGetUnreadCommentsHook();

  const queryFn: QueryFunction<
    Awaited<
      ReturnType<ReturnType<typeof useTransportLogisticsGetUnreadCommentsHook>>
    >
  > = ({ signal }) => transportLogisticsGetUnreadComments(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<
      ReturnType<ReturnType<typeof useTransportLogisticsGetUnreadCommentsHook>>
    >,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type TransportLogisticsGetUnreadCommentsQueryResult = NonNullable<
  Awaited<
    ReturnType<ReturnType<typeof useTransportLogisticsGetUnreadCommentsHook>>
  >
>;
export type TransportLogisticsGetUnreadCommentsQueryError = unknown;

export const useTransportLogisticsGetUnreadComments = <
  TData = Awaited<
    ReturnType<ReturnType<typeof useTransportLogisticsGetUnreadCommentsHook>>
  >,
  TError = unknown,
>(
  params?: TransportLogisticsGetUnreadCommentsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<
        ReturnType<
          ReturnType<typeof useTransportLogisticsGetUnreadCommentsHook>
        >
      >,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = useTransportLogisticsGetUnreadCommentsQueryOptions(
    params,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const useTransportLogisticsGetUnhandledFaultyCarsHook = () => {
  const transportLogisticsGetUnhandledFaultyCars =
    useCustomInstance<CaseEventDTOWithUserDetails[]>();

  return useCallback(
    (
      params?: TransportLogisticsGetUnhandledFaultyCarsParams,
      signal?: AbortSignal
    ) => {
      return transportLogisticsGetUnhandledFaultyCars({
        url: `/api/TransportLogistics/GetUnhandledFaultyCars`,
        method: 'GET',
        params,
        signal,
      });
    },
    [transportLogisticsGetUnhandledFaultyCars]
  );
};

export const getTransportLogisticsGetUnhandledFaultyCarsQueryKey = (
  params?: TransportLogisticsGetUnhandledFaultyCarsParams
) => {
  return [
    `/api/TransportLogistics/GetUnhandledFaultyCars`,
    ...(params ? [params] : []),
  ] as const;
};

export const useTransportLogisticsGetUnhandledFaultyCarsQueryOptions = <
  TData = Awaited<
    ReturnType<
      ReturnType<typeof useTransportLogisticsGetUnhandledFaultyCarsHook>
    >
  >,
  TError = unknown,
>(
  params?: TransportLogisticsGetUnhandledFaultyCarsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<
        ReturnType<
          ReturnType<typeof useTransportLogisticsGetUnhandledFaultyCarsHook>
        >
      >,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getTransportLogisticsGetUnhandledFaultyCarsQueryKey(params);

  const transportLogisticsGetUnhandledFaultyCars =
    useTransportLogisticsGetUnhandledFaultyCarsHook();

  const queryFn: QueryFunction<
    Awaited<
      ReturnType<
        ReturnType<typeof useTransportLogisticsGetUnhandledFaultyCarsHook>
      >
    >
  > = ({ signal }) => transportLogisticsGetUnhandledFaultyCars(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<
      ReturnType<
        ReturnType<typeof useTransportLogisticsGetUnhandledFaultyCarsHook>
      >
    >,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type TransportLogisticsGetUnhandledFaultyCarsQueryResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<typeof useTransportLogisticsGetUnhandledFaultyCarsHook>
    >
  >
>;
export type TransportLogisticsGetUnhandledFaultyCarsQueryError = unknown;

export const useTransportLogisticsGetUnhandledFaultyCars = <
  TData = Awaited<
    ReturnType<
      ReturnType<typeof useTransportLogisticsGetUnhandledFaultyCarsHook>
    >
  >,
  TError = unknown,
>(
  params?: TransportLogisticsGetUnhandledFaultyCarsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<
        ReturnType<
          ReturnType<typeof useTransportLogisticsGetUnhandledFaultyCarsHook>
        >
      >,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = useTransportLogisticsGetUnhandledFaultyCarsQueryOptions(
    params,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const useTransportLogisticsGetUnhandledDeviationReportsHook = () => {
  const transportLogisticsGetUnhandledDeviationReports =
    useCustomInstance<CaseEventDTOWithUserDetails[]>();

  return useCallback(
    (
      params?: TransportLogisticsGetUnhandledDeviationReportsParams,
      signal?: AbortSignal
    ) => {
      return transportLogisticsGetUnhandledDeviationReports({
        url: `/api/TransportLogistics/GetUnhandledDeviationReports`,
        method: 'GET',
        params,
        signal,
      });
    },
    [transportLogisticsGetUnhandledDeviationReports]
  );
};

export const getTransportLogisticsGetUnhandledDeviationReportsQueryKey = (
  params?: TransportLogisticsGetUnhandledDeviationReportsParams
) => {
  return [
    `/api/TransportLogistics/GetUnhandledDeviationReports`,
    ...(params ? [params] : []),
  ] as const;
};

export const useTransportLogisticsGetUnhandledDeviationReportsQueryOptions = <
  TData = Awaited<
    ReturnType<
      ReturnType<typeof useTransportLogisticsGetUnhandledDeviationReportsHook>
    >
  >,
  TError = unknown,
>(
  params?: TransportLogisticsGetUnhandledDeviationReportsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<
        ReturnType<
          ReturnType<
            typeof useTransportLogisticsGetUnhandledDeviationReportsHook
          >
        >
      >,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getTransportLogisticsGetUnhandledDeviationReportsQueryKey(params);

  const transportLogisticsGetUnhandledDeviationReports =
    useTransportLogisticsGetUnhandledDeviationReportsHook();

  const queryFn: QueryFunction<
    Awaited<
      ReturnType<
        ReturnType<typeof useTransportLogisticsGetUnhandledDeviationReportsHook>
      >
    >
  > = ({ signal }) =>
    transportLogisticsGetUnhandledDeviationReports(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<
      ReturnType<
        ReturnType<typeof useTransportLogisticsGetUnhandledDeviationReportsHook>
      >
    >,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type TransportLogisticsGetUnhandledDeviationReportsQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        ReturnType<typeof useTransportLogisticsGetUnhandledDeviationReportsHook>
      >
    >
  >;
export type TransportLogisticsGetUnhandledDeviationReportsQueryError = unknown;

export const useTransportLogisticsGetUnhandledDeviationReports = <
  TData = Awaited<
    ReturnType<
      ReturnType<typeof useTransportLogisticsGetUnhandledDeviationReportsHook>
    >
  >,
  TError = unknown,
>(
  params?: TransportLogisticsGetUnhandledDeviationReportsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<
        ReturnType<
          ReturnType<
            typeof useTransportLogisticsGetUnhandledDeviationReportsHook
          >
        >
      >,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions =
    useTransportLogisticsGetUnhandledDeviationReportsQueryOptions(
      params,
      options
    );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const useTransportLogisticsGetAssignmentBookedToEditedByFieldtesterHook =
  () => {
    const transportLogisticsGetAssignmentBookedToEditedByFieldtester =
      useCustomInstance<CaseEventDTOWithUserDetails[]>();

    return useCallback(
      (
        params?: TransportLogisticsGetAssignmentBookedToEditedByFieldtesterParams,
        signal?: AbortSignal
      ) => {
        return transportLogisticsGetAssignmentBookedToEditedByFieldtester({
          url: `/api/TransportLogistics/GetAssignmentBookedToEditedByFieldtester`,
          method: 'GET',
          params,
          signal,
        });
      },
      [transportLogisticsGetAssignmentBookedToEditedByFieldtester]
    );
  };

export const getTransportLogisticsGetAssignmentBookedToEditedByFieldtesterQueryKey =
  (
    params?: TransportLogisticsGetAssignmentBookedToEditedByFieldtesterParams
  ) => {
    return [
      `/api/TransportLogistics/GetAssignmentBookedToEditedByFieldtester`,
      ...(params ? [params] : []),
    ] as const;
  };

export const useTransportLogisticsGetAssignmentBookedToEditedByFieldtesterQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        ReturnType<
          typeof useTransportLogisticsGetAssignmentBookedToEditedByFieldtesterHook
        >
      >
    >,
    TError = unknown,
  >(
    params?: TransportLogisticsGetAssignmentBookedToEditedByFieldtesterParams,
    options?: {
      query?: UseQueryOptions<
        Awaited<
          ReturnType<
            ReturnType<
              typeof useTransportLogisticsGetAssignmentBookedToEditedByFieldtesterHook
            >
          >
        >,
        TError,
        TData
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getTransportLogisticsGetAssignmentBookedToEditedByFieldtesterQueryKey(
        params
      );

    const transportLogisticsGetAssignmentBookedToEditedByFieldtester =
      useTransportLogisticsGetAssignmentBookedToEditedByFieldtesterHook();

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          ReturnType<
            typeof useTransportLogisticsGetAssignmentBookedToEditedByFieldtesterHook
          >
        >
      >
    > = ({ signal }) =>
      transportLogisticsGetAssignmentBookedToEditedByFieldtester(
        params,
        signal
      );

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<
          ReturnType<
            typeof useTransportLogisticsGetAssignmentBookedToEditedByFieldtesterHook
          >
        >
      >,
      TError,
      TData
    > & { queryKey: QueryKey };
  };

export type TransportLogisticsGetAssignmentBookedToEditedByFieldtesterQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        ReturnType<
          typeof useTransportLogisticsGetAssignmentBookedToEditedByFieldtesterHook
        >
      >
    >
  >;
export type TransportLogisticsGetAssignmentBookedToEditedByFieldtesterQueryError =
  unknown;

export const useTransportLogisticsGetAssignmentBookedToEditedByFieldtester = <
  TData = Awaited<
    ReturnType<
      ReturnType<
        typeof useTransportLogisticsGetAssignmentBookedToEditedByFieldtesterHook
      >
    >
  >,
  TError = unknown,
>(
  params?: TransportLogisticsGetAssignmentBookedToEditedByFieldtesterParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<
        ReturnType<
          ReturnType<
            typeof useTransportLogisticsGetAssignmentBookedToEditedByFieldtesterHook
          >
        >
      >,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions =
    useTransportLogisticsGetAssignmentBookedToEditedByFieldtesterQueryOptions(
      params,
      options
    );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const useTransportLogisticsGetAssignmentsNotYetAcceptedByFTForTomorrowHook =
  () => {
    const transportLogisticsGetAssignmentsNotYetAcceptedByFTForTomorrow =
      useCustomInstance<AssignmentDTO[]>();

    return useCallback(
      (
        params?: TransportLogisticsGetAssignmentsNotYetAcceptedByFTForTomorrowParams,
        signal?: AbortSignal
      ) => {
        return transportLogisticsGetAssignmentsNotYetAcceptedByFTForTomorrow({
          url: `/api/TransportLogistics/GetAssignmentsNotYetAcceptedByFTForTomorrow`,
          method: 'GET',
          params,
          signal,
        });
      },
      [transportLogisticsGetAssignmentsNotYetAcceptedByFTForTomorrow]
    );
  };

export const getTransportLogisticsGetAssignmentsNotYetAcceptedByFTForTomorrowQueryKey =
  (
    params?: TransportLogisticsGetAssignmentsNotYetAcceptedByFTForTomorrowParams
  ) => {
    return [
      `/api/TransportLogistics/GetAssignmentsNotYetAcceptedByFTForTomorrow`,
      ...(params ? [params] : []),
    ] as const;
  };

export const useTransportLogisticsGetAssignmentsNotYetAcceptedByFTForTomorrowQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        ReturnType<
          typeof useTransportLogisticsGetAssignmentsNotYetAcceptedByFTForTomorrowHook
        >
      >
    >,
    TError = unknown,
  >(
    params?: TransportLogisticsGetAssignmentsNotYetAcceptedByFTForTomorrowParams,
    options?: {
      query?: UseQueryOptions<
        Awaited<
          ReturnType<
            ReturnType<
              typeof useTransportLogisticsGetAssignmentsNotYetAcceptedByFTForTomorrowHook
            >
          >
        >,
        TError,
        TData
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getTransportLogisticsGetAssignmentsNotYetAcceptedByFTForTomorrowQueryKey(
        params
      );

    const transportLogisticsGetAssignmentsNotYetAcceptedByFTForTomorrow =
      useTransportLogisticsGetAssignmentsNotYetAcceptedByFTForTomorrowHook();

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          ReturnType<
            typeof useTransportLogisticsGetAssignmentsNotYetAcceptedByFTForTomorrowHook
          >
        >
      >
    > = ({ signal }) =>
      transportLogisticsGetAssignmentsNotYetAcceptedByFTForTomorrow(
        params,
        signal
      );

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<
          ReturnType<
            typeof useTransportLogisticsGetAssignmentsNotYetAcceptedByFTForTomorrowHook
          >
        >
      >,
      TError,
      TData
    > & { queryKey: QueryKey };
  };

export type TransportLogisticsGetAssignmentsNotYetAcceptedByFTForTomorrowQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        ReturnType<
          typeof useTransportLogisticsGetAssignmentsNotYetAcceptedByFTForTomorrowHook
        >
      >
    >
  >;
export type TransportLogisticsGetAssignmentsNotYetAcceptedByFTForTomorrowQueryError =
  unknown;

export const useTransportLogisticsGetAssignmentsNotYetAcceptedByFTForTomorrow =
  <
    TData = Awaited<
      ReturnType<
        ReturnType<
          typeof useTransportLogisticsGetAssignmentsNotYetAcceptedByFTForTomorrowHook
        >
      >
    >,
    TError = unknown,
  >(
    params?: TransportLogisticsGetAssignmentsNotYetAcceptedByFTForTomorrowParams,
    options?: {
      query?: UseQueryOptions<
        Awaited<
          ReturnType<
            ReturnType<
              typeof useTransportLogisticsGetAssignmentsNotYetAcceptedByFTForTomorrowHook
            >
          >
        >,
        TError,
        TData
      >;
    }
  ): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
    const queryOptions =
      useTransportLogisticsGetAssignmentsNotYetAcceptedByFTForTomorrowQueryOptions(
        params,
        options
      );

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
      queryKey: QueryKey;
    };

    query.queryKey = queryOptions.queryKey;

    return query;
  };

export const useTransportLogisticsGetAssignmentsEstimatedStartTimePassedHook =
  () => {
    const transportLogisticsGetAssignmentsEstimatedStartTimePassed =
      useCustomInstance<AssignmentDTO[]>();

    return useCallback(
      (
        params?: TransportLogisticsGetAssignmentsEstimatedStartTimePassedParams,
        signal?: AbortSignal
      ) => {
        return transportLogisticsGetAssignmentsEstimatedStartTimePassed({
          url: `/api/TransportLogistics/GetAssignmentsEstimatedStartTimePassed`,
          method: 'GET',
          params,
          signal,
        });
      },
      [transportLogisticsGetAssignmentsEstimatedStartTimePassed]
    );
  };

export const getTransportLogisticsGetAssignmentsEstimatedStartTimePassedQueryKey =
  (params?: TransportLogisticsGetAssignmentsEstimatedStartTimePassedParams) => {
    return [
      `/api/TransportLogistics/GetAssignmentsEstimatedStartTimePassed`,
      ...(params ? [params] : []),
    ] as const;
  };

export const useTransportLogisticsGetAssignmentsEstimatedStartTimePassedQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        ReturnType<
          typeof useTransportLogisticsGetAssignmentsEstimatedStartTimePassedHook
        >
      >
    >,
    TError = unknown,
  >(
    params?: TransportLogisticsGetAssignmentsEstimatedStartTimePassedParams,
    options?: {
      query?: UseQueryOptions<
        Awaited<
          ReturnType<
            ReturnType<
              typeof useTransportLogisticsGetAssignmentsEstimatedStartTimePassedHook
            >
          >
        >,
        TError,
        TData
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getTransportLogisticsGetAssignmentsEstimatedStartTimePassedQueryKey(
        params
      );

    const transportLogisticsGetAssignmentsEstimatedStartTimePassed =
      useTransportLogisticsGetAssignmentsEstimatedStartTimePassedHook();

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          ReturnType<
            typeof useTransportLogisticsGetAssignmentsEstimatedStartTimePassedHook
          >
        >
      >
    > = ({ signal }) =>
      transportLogisticsGetAssignmentsEstimatedStartTimePassed(params, signal);

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<
          ReturnType<
            typeof useTransportLogisticsGetAssignmentsEstimatedStartTimePassedHook
          >
        >
      >,
      TError,
      TData
    > & { queryKey: QueryKey };
  };

export type TransportLogisticsGetAssignmentsEstimatedStartTimePassedQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        ReturnType<
          typeof useTransportLogisticsGetAssignmentsEstimatedStartTimePassedHook
        >
      >
    >
  >;
export type TransportLogisticsGetAssignmentsEstimatedStartTimePassedQueryError =
  unknown;

export const useTransportLogisticsGetAssignmentsEstimatedStartTimePassed = <
  TData = Awaited<
    ReturnType<
      ReturnType<
        typeof useTransportLogisticsGetAssignmentsEstimatedStartTimePassedHook
      >
    >
  >,
  TError = unknown,
>(
  params?: TransportLogisticsGetAssignmentsEstimatedStartTimePassedParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<
        ReturnType<
          ReturnType<
            typeof useTransportLogisticsGetAssignmentsEstimatedStartTimePassedHook
          >
        >
      >,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions =
    useTransportLogisticsGetAssignmentsEstimatedStartTimePassedQueryOptions(
      params,
      options
    );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const useTransportLogisticsGetAssignmentsEstimatedEndTimePassedHook =
  () => {
    const transportLogisticsGetAssignmentsEstimatedEndTimePassed =
      useCustomInstance<AssignmentDTO[]>();

    return useCallback(
      (
        params?: TransportLogisticsGetAssignmentsEstimatedEndTimePassedParams,
        signal?: AbortSignal
      ) => {
        return transportLogisticsGetAssignmentsEstimatedEndTimePassed({
          url: `/api/TransportLogistics/GetAssignmentsEstimatedEndTimePassed`,
          method: 'GET',
          params,
          signal,
        });
      },
      [transportLogisticsGetAssignmentsEstimatedEndTimePassed]
    );
  };

export const getTransportLogisticsGetAssignmentsEstimatedEndTimePassedQueryKey =
  (params?: TransportLogisticsGetAssignmentsEstimatedEndTimePassedParams) => {
    return [
      `/api/TransportLogistics/GetAssignmentsEstimatedEndTimePassed`,
      ...(params ? [params] : []),
    ] as const;
  };

export const useTransportLogisticsGetAssignmentsEstimatedEndTimePassedQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        ReturnType<
          typeof useTransportLogisticsGetAssignmentsEstimatedEndTimePassedHook
        >
      >
    >,
    TError = unknown,
  >(
    params?: TransportLogisticsGetAssignmentsEstimatedEndTimePassedParams,
    options?: {
      query?: UseQueryOptions<
        Awaited<
          ReturnType<
            ReturnType<
              typeof useTransportLogisticsGetAssignmentsEstimatedEndTimePassedHook
            >
          >
        >,
        TError,
        TData
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getTransportLogisticsGetAssignmentsEstimatedEndTimePassedQueryKey(params);

    const transportLogisticsGetAssignmentsEstimatedEndTimePassed =
      useTransportLogisticsGetAssignmentsEstimatedEndTimePassedHook();

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          ReturnType<
            typeof useTransportLogisticsGetAssignmentsEstimatedEndTimePassedHook
          >
        >
      >
    > = ({ signal }) =>
      transportLogisticsGetAssignmentsEstimatedEndTimePassed(params, signal);

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<
          ReturnType<
            typeof useTransportLogisticsGetAssignmentsEstimatedEndTimePassedHook
          >
        >
      >,
      TError,
      TData
    > & { queryKey: QueryKey };
  };

export type TransportLogisticsGetAssignmentsEstimatedEndTimePassedQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        ReturnType<
          typeof useTransportLogisticsGetAssignmentsEstimatedEndTimePassedHook
        >
      >
    >
  >;
export type TransportLogisticsGetAssignmentsEstimatedEndTimePassedQueryError =
  unknown;

export const useTransportLogisticsGetAssignmentsEstimatedEndTimePassed = <
  TData = Awaited<
    ReturnType<
      ReturnType<
        typeof useTransportLogisticsGetAssignmentsEstimatedEndTimePassedHook
      >
    >
  >,
  TError = unknown,
>(
  params?: TransportLogisticsGetAssignmentsEstimatedEndTimePassedParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<
        ReturnType<
          ReturnType<
            typeof useTransportLogisticsGetAssignmentsEstimatedEndTimePassedHook
          >
        >
      >,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions =
    useTransportLogisticsGetAssignmentsEstimatedEndTimePassedQueryOptions(
      params,
      options
    );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const useTransportLogisticsGetAssignmentsBookedToTimePassedHook = () => {
  const transportLogisticsGetAssignmentsBookedToTimePassed =
    useCustomInstance<AssignmentDTO[]>();

  return useCallback(
    (
      params?: TransportLogisticsGetAssignmentsBookedToTimePassedParams,
      signal?: AbortSignal
    ) => {
      return transportLogisticsGetAssignmentsBookedToTimePassed({
        url: `/api/TransportLogistics/GetAssignmentsBookedToTimePassed`,
        method: 'GET',
        params,
        signal,
      });
    },
    [transportLogisticsGetAssignmentsBookedToTimePassed]
  );
};

export const getTransportLogisticsGetAssignmentsBookedToTimePassedQueryKey = (
  params?: TransportLogisticsGetAssignmentsBookedToTimePassedParams
) => {
  return [
    `/api/TransportLogistics/GetAssignmentsBookedToTimePassed`,
    ...(params ? [params] : []),
  ] as const;
};

export const useTransportLogisticsGetAssignmentsBookedToTimePassedQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        ReturnType<
          typeof useTransportLogisticsGetAssignmentsBookedToTimePassedHook
        >
      >
    >,
    TError = unknown,
  >(
    params?: TransportLogisticsGetAssignmentsBookedToTimePassedParams,
    options?: {
      query?: UseQueryOptions<
        Awaited<
          ReturnType<
            ReturnType<
              typeof useTransportLogisticsGetAssignmentsBookedToTimePassedHook
            >
          >
        >,
        TError,
        TData
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getTransportLogisticsGetAssignmentsBookedToTimePassedQueryKey(params);

    const transportLogisticsGetAssignmentsBookedToTimePassed =
      useTransportLogisticsGetAssignmentsBookedToTimePassedHook();

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          ReturnType<
            typeof useTransportLogisticsGetAssignmentsBookedToTimePassedHook
          >
        >
      >
    > = ({ signal }) =>
      transportLogisticsGetAssignmentsBookedToTimePassed(params, signal);

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<
          ReturnType<
            typeof useTransportLogisticsGetAssignmentsBookedToTimePassedHook
          >
        >
      >,
      TError,
      TData
    > & { queryKey: QueryKey };
  };

export type TransportLogisticsGetAssignmentsBookedToTimePassedQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        ReturnType<
          typeof useTransportLogisticsGetAssignmentsBookedToTimePassedHook
        >
      >
    >
  >;
export type TransportLogisticsGetAssignmentsBookedToTimePassedQueryError =
  unknown;

export const useTransportLogisticsGetAssignmentsBookedToTimePassed = <
  TData = Awaited<
    ReturnType<
      ReturnType<
        typeof useTransportLogisticsGetAssignmentsBookedToTimePassedHook
      >
    >
  >,
  TError = unknown,
>(
  params?: TransportLogisticsGetAssignmentsBookedToTimePassedParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<
        ReturnType<
          ReturnType<
            typeof useTransportLogisticsGetAssignmentsBookedToTimePassedHook
          >
        >
      >,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions =
    useTransportLogisticsGetAssignmentsBookedToTimePassedQueryOptions(
      params,
      options
    );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const useTransportLogisticsGetUnhandledWorkGearReportsHook = () => {
  const transportLogisticsGetUnhandledWorkGearReports =
    useCustomInstance<CaseEventDTOWithUserDetails[]>();

  return useCallback(
    (
      params?: TransportLogisticsGetUnhandledWorkGearReportsParams,
      signal?: AbortSignal
    ) => {
      return transportLogisticsGetUnhandledWorkGearReports({
        url: `/api/TransportLogistics/GetUnhandledWorkGearReports`,
        method: 'GET',
        params,
        signal,
      });
    },
    [transportLogisticsGetUnhandledWorkGearReports]
  );
};

export const getTransportLogisticsGetUnhandledWorkGearReportsQueryKey = (
  params?: TransportLogisticsGetUnhandledWorkGearReportsParams
) => {
  return [
    `/api/TransportLogistics/GetUnhandledWorkGearReports`,
    ...(params ? [params] : []),
  ] as const;
};

export const useTransportLogisticsGetUnhandledWorkGearReportsQueryOptions = <
  TData = Awaited<
    ReturnType<
      ReturnType<typeof useTransportLogisticsGetUnhandledWorkGearReportsHook>
    >
  >,
  TError = unknown,
>(
  params?: TransportLogisticsGetUnhandledWorkGearReportsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<
        ReturnType<
          ReturnType<
            typeof useTransportLogisticsGetUnhandledWorkGearReportsHook
          >
        >
      >,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getTransportLogisticsGetUnhandledWorkGearReportsQueryKey(params);

  const transportLogisticsGetUnhandledWorkGearReports =
    useTransportLogisticsGetUnhandledWorkGearReportsHook();

  const queryFn: QueryFunction<
    Awaited<
      ReturnType<
        ReturnType<typeof useTransportLogisticsGetUnhandledWorkGearReportsHook>
      >
    >
  > = ({ signal }) =>
    transportLogisticsGetUnhandledWorkGearReports(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<
      ReturnType<
        ReturnType<typeof useTransportLogisticsGetUnhandledWorkGearReportsHook>
      >
    >,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type TransportLogisticsGetUnhandledWorkGearReportsQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        ReturnType<typeof useTransportLogisticsGetUnhandledWorkGearReportsHook>
      >
    >
  >;
export type TransportLogisticsGetUnhandledWorkGearReportsQueryError = unknown;

export const useTransportLogisticsGetUnhandledWorkGearReports = <
  TData = Awaited<
    ReturnType<
      ReturnType<typeof useTransportLogisticsGetUnhandledWorkGearReportsHook>
    >
  >,
  TError = unknown,
>(
  params?: TransportLogisticsGetUnhandledWorkGearReportsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<
        ReturnType<
          ReturnType<
            typeof useTransportLogisticsGetUnhandledWorkGearReportsHook
          >
        >
      >,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions =
    useTransportLogisticsGetUnhandledWorkGearReportsQueryOptions(
      params,
      options
    );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const useTransportLogisticsGetUnhandledFlaggedForSpeedingHook = () => {
  const transportLogisticsGetUnhandledFlaggedForSpeeding =
    useCustomInstance<CaseEventDTOWithUserDetails[]>();

  return useCallback(
    (
      params?: TransportLogisticsGetUnhandledFlaggedForSpeedingParams,
      signal?: AbortSignal
    ) => {
      return transportLogisticsGetUnhandledFlaggedForSpeeding({
        url: `/api/TransportLogistics/GetUnhandledFlaggedForSpeeding`,
        method: 'GET',
        params,
        signal,
      });
    },
    [transportLogisticsGetUnhandledFlaggedForSpeeding]
  );
};

export const getTransportLogisticsGetUnhandledFlaggedForSpeedingQueryKey = (
  params?: TransportLogisticsGetUnhandledFlaggedForSpeedingParams
) => {
  return [
    `/api/TransportLogistics/GetUnhandledFlaggedForSpeeding`,
    ...(params ? [params] : []),
  ] as const;
};

export const useTransportLogisticsGetUnhandledFlaggedForSpeedingQueryOptions = <
  TData = Awaited<
    ReturnType<
      ReturnType<typeof useTransportLogisticsGetUnhandledFlaggedForSpeedingHook>
    >
  >,
  TError = unknown,
>(
  params?: TransportLogisticsGetUnhandledFlaggedForSpeedingParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<
        ReturnType<
          ReturnType<
            typeof useTransportLogisticsGetUnhandledFlaggedForSpeedingHook
          >
        >
      >,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getTransportLogisticsGetUnhandledFlaggedForSpeedingQueryKey(params);

  const transportLogisticsGetUnhandledFlaggedForSpeeding =
    useTransportLogisticsGetUnhandledFlaggedForSpeedingHook();

  const queryFn: QueryFunction<
    Awaited<
      ReturnType<
        ReturnType<
          typeof useTransportLogisticsGetUnhandledFlaggedForSpeedingHook
        >
      >
    >
  > = ({ signal }) =>
    transportLogisticsGetUnhandledFlaggedForSpeeding(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<
      ReturnType<
        ReturnType<
          typeof useTransportLogisticsGetUnhandledFlaggedForSpeedingHook
        >
      >
    >,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type TransportLogisticsGetUnhandledFlaggedForSpeedingQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        ReturnType<
          typeof useTransportLogisticsGetUnhandledFlaggedForSpeedingHook
        >
      >
    >
  >;
export type TransportLogisticsGetUnhandledFlaggedForSpeedingQueryError =
  unknown;

export const useTransportLogisticsGetUnhandledFlaggedForSpeeding = <
  TData = Awaited<
    ReturnType<
      ReturnType<typeof useTransportLogisticsGetUnhandledFlaggedForSpeedingHook>
    >
  >,
  TError = unknown,
>(
  params?: TransportLogisticsGetUnhandledFlaggedForSpeedingParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<
        ReturnType<
          ReturnType<
            typeof useTransportLogisticsGetUnhandledFlaggedForSpeedingHook
          >
        >
      >,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions =
    useTransportLogisticsGetUnhandledFlaggedForSpeedingQueryOptions(
      params,
      options
    );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const useTransportLogisticsGetUnhandledNoTyresLoadedEventsHook = () => {
  const transportLogisticsGetUnhandledNoTyresLoadedEvents =
    useCustomInstance<CaseEventDTOWithUserDetails[]>();

  return useCallback(
    (
      params?: TransportLogisticsGetUnhandledNoTyresLoadedEventsParams,
      signal?: AbortSignal
    ) => {
      return transportLogisticsGetUnhandledNoTyresLoadedEvents({
        url: `/api/TransportLogistics/GetUnhandledNoTyresLoadedEvents`,
        method: 'GET',
        params,
        signal,
      });
    },
    [transportLogisticsGetUnhandledNoTyresLoadedEvents]
  );
};

export const getTransportLogisticsGetUnhandledNoTyresLoadedEventsQueryKey = (
  params?: TransportLogisticsGetUnhandledNoTyresLoadedEventsParams
) => {
  return [
    `/api/TransportLogistics/GetUnhandledNoTyresLoadedEvents`,
    ...(params ? [params] : []),
  ] as const;
};

export const useTransportLogisticsGetUnhandledNoTyresLoadedEventsQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        ReturnType<
          typeof useTransportLogisticsGetUnhandledNoTyresLoadedEventsHook
        >
      >
    >,
    TError = unknown,
  >(
    params?: TransportLogisticsGetUnhandledNoTyresLoadedEventsParams,
    options?: {
      query?: UseQueryOptions<
        Awaited<
          ReturnType<
            ReturnType<
              typeof useTransportLogisticsGetUnhandledNoTyresLoadedEventsHook
            >
          >
        >,
        TError,
        TData
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getTransportLogisticsGetUnhandledNoTyresLoadedEventsQueryKey(params);

    const transportLogisticsGetUnhandledNoTyresLoadedEvents =
      useTransportLogisticsGetUnhandledNoTyresLoadedEventsHook();

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          ReturnType<
            typeof useTransportLogisticsGetUnhandledNoTyresLoadedEventsHook
          >
        >
      >
    > = ({ signal }) =>
      transportLogisticsGetUnhandledNoTyresLoadedEvents(params, signal);

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<
          ReturnType<
            typeof useTransportLogisticsGetUnhandledNoTyresLoadedEventsHook
          >
        >
      >,
      TError,
      TData
    > & { queryKey: QueryKey };
  };

export type TransportLogisticsGetUnhandledNoTyresLoadedEventsQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        ReturnType<
          typeof useTransportLogisticsGetUnhandledNoTyresLoadedEventsHook
        >
      >
    >
  >;
export type TransportLogisticsGetUnhandledNoTyresLoadedEventsQueryError =
  unknown;

export const useTransportLogisticsGetUnhandledNoTyresLoadedEvents = <
  TData = Awaited<
    ReturnType<
      ReturnType<
        typeof useTransportLogisticsGetUnhandledNoTyresLoadedEventsHook
      >
    >
  >,
  TError = unknown,
>(
  params?: TransportLogisticsGetUnhandledNoTyresLoadedEventsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<
        ReturnType<
          ReturnType<
            typeof useTransportLogisticsGetUnhandledNoTyresLoadedEventsHook
          >
        >
      >,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions =
    useTransportLogisticsGetUnhandledNoTyresLoadedEventsQueryOptions(
      params,
      options
    );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const useTransportLogisticsGetUnhandledAssignmentRescheduledToAfterMidnightHook =
  () => {
    const transportLogisticsGetUnhandledAssignmentRescheduledToAfterMidnight =
      useCustomInstance<CaseEventDTOWithUserDetails[]>();

    return useCallback(
      (
        params?: TransportLogisticsGetUnhandledAssignmentRescheduledToAfterMidnightParams,
        signal?: AbortSignal
      ) => {
        return transportLogisticsGetUnhandledAssignmentRescheduledToAfterMidnight(
          {
            url: `/api/TransportLogistics/GetUnhandledAssignmentRescheduledToAfterMidnight`,
            method: 'GET',
            params,
            signal,
          }
        );
      },
      [transportLogisticsGetUnhandledAssignmentRescheduledToAfterMidnight]
    );
  };

export const getTransportLogisticsGetUnhandledAssignmentRescheduledToAfterMidnightQueryKey =
  (
    params?: TransportLogisticsGetUnhandledAssignmentRescheduledToAfterMidnightParams
  ) => {
    return [
      `/api/TransportLogistics/GetUnhandledAssignmentRescheduledToAfterMidnight`,
      ...(params ? [params] : []),
    ] as const;
  };

export const useTransportLogisticsGetUnhandledAssignmentRescheduledToAfterMidnightQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        ReturnType<
          typeof useTransportLogisticsGetUnhandledAssignmentRescheduledToAfterMidnightHook
        >
      >
    >,
    TError = unknown,
  >(
    params?: TransportLogisticsGetUnhandledAssignmentRescheduledToAfterMidnightParams,
    options?: {
      query?: UseQueryOptions<
        Awaited<
          ReturnType<
            ReturnType<
              typeof useTransportLogisticsGetUnhandledAssignmentRescheduledToAfterMidnightHook
            >
          >
        >,
        TError,
        TData
      >;
    }
  ) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getTransportLogisticsGetUnhandledAssignmentRescheduledToAfterMidnightQueryKey(
        params
      );

    const transportLogisticsGetUnhandledAssignmentRescheduledToAfterMidnight =
      useTransportLogisticsGetUnhandledAssignmentRescheduledToAfterMidnightHook();

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          ReturnType<
            typeof useTransportLogisticsGetUnhandledAssignmentRescheduledToAfterMidnightHook
          >
        >
      >
    > = ({ signal }) =>
      transportLogisticsGetUnhandledAssignmentRescheduledToAfterMidnight(
        params,
        signal
      );

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<
          ReturnType<
            typeof useTransportLogisticsGetUnhandledAssignmentRescheduledToAfterMidnightHook
          >
        >
      >,
      TError,
      TData
    > & { queryKey: QueryKey };
  };

export type TransportLogisticsGetUnhandledAssignmentRescheduledToAfterMidnightQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        ReturnType<
          typeof useTransportLogisticsGetUnhandledAssignmentRescheduledToAfterMidnightHook
        >
      >
    >
  >;
export type TransportLogisticsGetUnhandledAssignmentRescheduledToAfterMidnightQueryError =
  unknown;

export const useTransportLogisticsGetUnhandledAssignmentRescheduledToAfterMidnight =
  <
    TData = Awaited<
      ReturnType<
        ReturnType<
          typeof useTransportLogisticsGetUnhandledAssignmentRescheduledToAfterMidnightHook
        >
      >
    >,
    TError = unknown,
  >(
    params?: TransportLogisticsGetUnhandledAssignmentRescheduledToAfterMidnightParams,
    options?: {
      query?: UseQueryOptions<
        Awaited<
          ReturnType<
            ReturnType<
              typeof useTransportLogisticsGetUnhandledAssignmentRescheduledToAfterMidnightHook
            >
          >
        >,
        TError,
        TData
      >;
    }
  ): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
    const queryOptions =
      useTransportLogisticsGetUnhandledAssignmentRescheduledToAfterMidnightQueryOptions(
        params,
        options
      );

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
      queryKey: QueryKey;
    };

    query.queryKey = queryOptions.queryKey;

    return query;
  };

export const useTransportLogisticsGetStandbyTimeAssignmentsHook = () => {
  const transportLogisticsGetStandbyTimeAssignments =
    useCustomInstance<AssignmentDTO[]>();

  return useCallback(
    (
      params?: TransportLogisticsGetStandbyTimeAssignmentsParams,
      signal?: AbortSignal
    ) => {
      return transportLogisticsGetStandbyTimeAssignments({
        url: `/api/TransportLogistics/GetStandbyTimeAssignments`,
        method: 'GET',
        params,
        signal,
      });
    },
    [transportLogisticsGetStandbyTimeAssignments]
  );
};

export const getTransportLogisticsGetStandbyTimeAssignmentsQueryKey = (
  params?: TransportLogisticsGetStandbyTimeAssignmentsParams
) => {
  return [
    `/api/TransportLogistics/GetStandbyTimeAssignments`,
    ...(params ? [params] : []),
  ] as const;
};

export const useTransportLogisticsGetStandbyTimeAssignmentsQueryOptions = <
  TData = Awaited<
    ReturnType<
      ReturnType<typeof useTransportLogisticsGetStandbyTimeAssignmentsHook>
    >
  >,
  TError = unknown,
>(
  params?: TransportLogisticsGetStandbyTimeAssignmentsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<
        ReturnType<
          ReturnType<typeof useTransportLogisticsGetStandbyTimeAssignmentsHook>
        >
      >,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getTransportLogisticsGetStandbyTimeAssignmentsQueryKey(params);

  const transportLogisticsGetStandbyTimeAssignments =
    useTransportLogisticsGetStandbyTimeAssignmentsHook();

  const queryFn: QueryFunction<
    Awaited<
      ReturnType<
        ReturnType<typeof useTransportLogisticsGetStandbyTimeAssignmentsHook>
      >
    >
  > = ({ signal }) =>
    transportLogisticsGetStandbyTimeAssignments(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<
      ReturnType<
        ReturnType<typeof useTransportLogisticsGetStandbyTimeAssignmentsHook>
      >
    >,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type TransportLogisticsGetStandbyTimeAssignmentsQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        ReturnType<typeof useTransportLogisticsGetStandbyTimeAssignmentsHook>
      >
    >
  >;
export type TransportLogisticsGetStandbyTimeAssignmentsQueryError = unknown;

export const useTransportLogisticsGetStandbyTimeAssignments = <
  TData = Awaited<
    ReturnType<
      ReturnType<typeof useTransportLogisticsGetStandbyTimeAssignmentsHook>
    >
  >,
  TError = unknown,
>(
  params?: TransportLogisticsGetStandbyTimeAssignmentsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<
        ReturnType<
          ReturnType<typeof useTransportLogisticsGetStandbyTimeAssignmentsHook>
        >
      >,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions =
    useTransportLogisticsGetStandbyTimeAssignmentsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};
